import SystemSettingsAPI from "../../../api/SystemSettingsAPI";

export default {
  async setContractSettings({commit}, settings) {
    let response = await new SystemSettingsAPI().setContractSettings(settings);
    commit('SET_SYSTEM_SETTINGS', response);
  },

  async saveCounterpartyGroup({commit}, counterpartyGroup) {
    let response = await new SystemSettingsAPI().saveCounterpartyGroup(counterpartyGroup);
    commit('SET_COUNTERPARTY_GROUP', response);
  },

  async loadCounterpartyGroup({commit}) {
    const response = await new SystemSettingsAPI().getCounterpartyGroup();
    commit('SET_COUNTERPARTY_GROUP', response);
    return response;
  },

  async loadContractSettings({commit}) {
    const response = await new SystemSettingsAPI().getContractSettings();
    commit('SET_SYSTEM_SETTINGS', response);
    return response;
  }
};
